export default {
   methods: {
      analysisLevelColor: function (analysisLevel) {
         if(analysisLevel === 'VERY_GOOD'
            || analysisLevel === 'GOOD')
         {
            return "success";
         }
         else if(analysisLevel === 'BAD')
         {
            return "warning";
         }
         else if(analysisLevel === 'VERY_BAD')
         {
            return "danger";
         }
         return "default";
      }
   }
}